import {
  useLessonRecordingByLessonQuery,
  GroupLessonForZoomFieldsFragment,
  LessonRecordingFieldsFragment,
} from 'core/graphql';

interface ILessonRecordingHook {
  lesson?: GroupLessonForZoomFieldsFragment;
  recording: LessonRecordingFieldsFragment | null;
  loading: boolean;
  error?: string;
  refetch: () => void;
  startPolling: (interval: number) => void;
  stopPolling: () => void;
}

/**
 * Loads a single lesson for the `/zoom/lessons/:id` card via the ERP-scoped
 * `zoomLesson` query — keyed by the GroupLesson id, returns the lesson with its
 * optional `zoomRecordingMeta` (the LessonRecording).
 */
export const useLessonRecording = (
  groupLessonId?: string,
): ILessonRecordingHook => {
  const {
    data,
    loading,
    error,
    refetch,
    startPolling,
    stopPolling,
  } = useLessonRecordingByLessonQuery({
    variables: { groupLessonId: groupLessonId ?? '' },
    skip: !groupLessonId,
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });

  const lesson = data?.zoomLesson ?? undefined;

  return {
    lesson,
    recording: lesson?.zoomRecordingMeta ?? null,
    loading,
    error: error?.message,
    refetch: () => {
      refetch();
    },
    startPolling,
    stopPolling,
  };
};
